import React from 'react'
import Image from './Image.js'

const InteractiveImage = ({ onClick, active }) => <Image onClick={onClick} active={active} />

export default InteractiveImage
